import React from 'react';

interface CardProps {
  title: string;
  description: string;
  selected?: boolean;
  onClick: () => void;
}

export const Card: React.FC<CardProps> = ({ title, description, selected, onClick }) => {
  return (
    <div
      className={`border border-border p-5 mb-3 cursor-pointer transition-all duration-300 ${
        selected ? 'border-primary bg-[#FAFAFA]' : 'hover:border-primary'
      }`}
      onClick={onClick}
    >
      <div className="text-base font-medium mb-1">{title}</div>
      <div className="text-sm text-secondary">{description}</div>
    </div>
  );
};
